import ApiClient from "shared/service/api/ApiClient";
import { Client } from "shared/service/api/generated";
import { Employee } from "../models";
import { GetEmployeesParameters } from "./contracts";

class EmployeesService {
    private apiClient: Client;

    constructor(apiClient: Client) {
        this.apiClient = apiClient;
    }

    async getEmployeesList(params: GetEmployeesParameters): Promise<{ employees: Employee[]; hasMore: boolean }> {
        return this.getEmployeesBase(params);
    }

    private async getEmployeesBase(
        params: GetEmployeesParameters
    ): Promise<{ employees: Employee[]; hasMore: boolean }> {
        let { id, offset, limit, phrase } = params;

        let response = await this.apiClient.v360_intermediary_employeeList(
            id,
            phrase,
            offset.toString(),
            limit.toString(),
            undefined
        );

        const employees =
            response.list?.map(
                (noteDto) =>
                    new Employee(
                        noteDto.id ?? 0,
                        noteDto.firstName ?? "",
                        noteDto.lastName ?? "",
                        noteDto.punu ?? "",
                        noteDto.tenantCodeList ?? []
                    )
            ) ?? [];

        return { employees: employees, hasMore: response.hasMore ?? false };
    }
}

export default new EmployeesService(ApiClient);
